import { Inspection, InspectionLog, ModelID, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'inspection-log_id';
export interface InspectionLogSearchParams
  extends SearchParams<Filter, Sort>,
    Partial<InspectionLog> {}

export const featurePath = (inspection: Inspection) =>
  `/v4/equipment/inspection/${inspection.id}/log`;

export const featureKeys = {
  all: [{ scope: 'inspection_log' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: InspectionLogSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
